import { authLayout } from "../helpers/withAuth";

export const topicModelingRoutes = {
  path: "topic-modeling",
  ...authLayout("Topic Modeling", [
    {
      path: "/topic-modeling/true-crime",
      lazy: () =>
        import("../../modules/topic-modeling/true-crime-v2").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/topic-modeling/true-crime/person/:name",
      lazy: () =>
        import("../../modules/topic-modeling/true-crime-v2/name-page").then(
          (m) => ({ Component: m.default }),
        ),
    },
    {
      path: "/topic-modeling/true-crime/topic/:topicId",
      lazy: () =>
        import("../../modules/topic-modeling/true-crime-v2/topic-page").then(
          (m) => ({ Component: m.default }),
        ),
    },
    {
      path: "/topic-modeling/pantheon",
      lazy: () =>
        import("../../modules/topic-modeling/pantheon").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/topic-modeling/pantheon/topic/:topicId",
      lazy: () =>
        import(
          "../../modules/topic-modeling/pantheon/components/TopicModelingPantheonTopicPage"
        ).then((m) => ({ Component: m.default })),
    },
  ]),
};
